import { useMemo } from 'react';

import { PinsCard } from './PinsCard';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { TipoProductoTO } from '@/types/myAccount';
import { PACKS_BY_NAME } from '@/utils';
import { PACKS_BY_ID } from '@/utils/constants';

export const ListPinsCards = ({ products }: { products: TipoProductoTO[] }) => {
  const { isMobile } = useIsDesktop();

  const productsByScreen = useMemo(() => {
    const desktopProducts = [
      ...products,
      {
        id: PACKS_BY_ID[PACKS_BY_NAME.PRINTED_TICKETS],
        precio: 7500,
        descripcion: 'Ticket Impreso',
        esPremium: false,
        cantidad: 5,
      },
    ];
    return isMobile ? products : desktopProducts;
  }, [isMobile, products]);

  return (
    <div className="flex flex-wrap gap-y-4 gap-x-[3%] mt-7 justify-around mx-auto md:justify-center lg:justify-between md:gap-x-[2%] lg:gap-x-0 lg:flex-1 lg:mt-14">
      {productsByScreen.map((product) => {
        return (
          product.id < PACKS_BY_ID[PACKS_BY_NAME.PIN_ESPECIAL_TDA_1] &&
          !product.esPremium && <PinsCard key={product.id} product={product} />
        );
      })}
    </div>
  );
};
